export const SortDirection = {
    Ascending: 'asc',
    Descending: 'desc'
} as const;

export type SortDirectionType = (typeof SortDirection)[keyof typeof SortDirection];
